import { serverTimeEndpoints } from "./server-time.api.ts"

export const {
  useFetchServerTimeQuery,
  endpoints: { fetchServerTime }
} = serverTimeEndpoints
